import { FormattedMessage, useIntl } from 'react-intl'
import _get from 'lodash/get';
import { useSelector } from 'react-redux';
import { HashratesChart } from '~/sha256/Hashrates';
import { useGetMinerQuery } from '@/shared/api/Hashrates';
import Card from '@/entities/Card';
import TextBlock from '@/shared/ui/TextBlock';
import { getPower } from '@/shared/utils/formatters';
import { 
  selectPollingInterval, 
} from "@/processes/Settings";
import { useMinerAccount } from "@/processes/MinerAccounts";

type HashratesWidgetProps = {
  className?: string;
}

const HashratesWidget = (props: HashratesWidgetProps) => {
  const { className } = props;
  const intl = useIntl();
  const pollingInterval = useSelector(selectPollingInterval);
  const { account, miner, coin } = useMinerAccount();

  const { data: minerData, isSuccess: isMinerSuccess } = useGetMinerQuery({ 
    coin,
    miner,
    account,
  }, { pollingInterval, skip: !(account || miner) });

  const hashrate = getPower(_get(minerData, 'hashrate', 0));
  const hashrateAverage = getPower(_get(minerData, 'hashrate24h', 0));

  return (
    <Card className={className} title={intl.formatMessage({ id: 'hashrates' })}>
      <div className="flex my-4 -mx-4">
        <TextBlock
          isLoading={!isMinerSuccess}
          rootClassName='mx-4'
          title={intl.formatMessage({ id: 'hashrates.current' })}
          value={hashrate.value}
          subValue={hashrate.suffix}
        />
        <TextBlock
          isLoading={!isMinerSuccess}
          rootClassName='mx-4'
          title={intl.formatMessage({ id: 'hashrates.avg' })}
          value={hashrateAverage.value}
          subValue={hashrateAverage.suffix}
        />
      </div>

      <HashratesChart/>
    </Card>
  );
}

export default HashratesWidget;
